export default __webpack_public_path__ + "static/media/my_story.34d621f5.pdf";